import 'dom4'
import 'svgxuse'
import domready from 'domready'
import TweenMax from 'gsap/TweenMax'
import Hurdler from 'hurdler'
import BrowserWarning from '../browser-warning'
import FixedLogo from '../fixed-logo'
import Cursor from '../cursor'
import InView from '../in-view'
import Studio from '../studio'
import Contact from '../contact'
import WorkItems from '../work-items'
import MarqueeText from '../marquee-text'
import CenteredTextBlock from '../centered-text-block'
import GlobalHeader from '../global-header'
import OpenClosed from '../open-closed'
import NowPlaying from '../now-playing'
import Project from '../project'
import DesktopVideo from '../desktop-video'
import MobileVideo from '../mobile-video'
import GlobalFooter from '../global-footer'

const hurdler = new Hurdler()
const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
const root = document.documentElement
const hours = new Date().getHours()
const isDayTime = hours > 8.5 && hours < 18

domready(() => {

  if (touchDevice) {
    root.classList.add('touch-device')
  }

  const body = document.body
  const loadingScreen = document.querySelector('[data-component="loading-screen"]')
  const outline = loadingScreen.querySelector('#outline')
  const solid = loadingScreen.querySelector('#solid')

  const outlineAnim = TweenMax.to(outline, .75, {transform: "translate3d(-1em, -1em, 0)", repeat:-1, yoyo:true, repeatDelay:0.5, ease:Bounce.easeOut});

  const solidAnim = TweenMax.to(solid, .75, {transform: "translate3d(1em, 1em, 0)", repeat:-1, yoyo:true, repeatDelay:0.5, ease:Bounce.easeOut});

  window.addEventListener('load', (event) => {
    loadingScreen.classList.add('page-loaded')
    body.classList.add('page-loaded')
    solidAnim.kill()
    outlineAnim.kill()
  })

  window.onmousemove = MouseMove

  function MouseMove() {
    let xCord = event.clientX
    let xPercent = xCord/window.innerWidth * 100
    let xRounded = Math.round(xPercent)
    let fixedLogo = document.querySelector('[data-component="fixed-logo"]')

    if (xRounded > 50) {
      fixedLogo.classList.add('logo-reversed')
      fixedLogo.classList.remove('logo-normal')
    } else {
      fixedLogo.classList.add('logo-normal')
      fixedLogo.classList.remove('logo-reversed')
    }
  }

  if (!isDayTime) {
    document.body.classList.add('night-time')
  }

  document.queryAll('.browser-warning').forEach(element => {
    new BrowserWarning({
      element
    })
  })

  if (!touchDevice) {
    document.queryAll('[data-component="cursor"]').forEach(element => {
      new Cursor({
        element
      })
    })
  }

  document.queryAll('[data-component="profiles"]').forEach(element => {
    new Profiles({
      element
    })
  })

  document.queryAll('[data-component="project"]').forEach(element => {
    new Project({
      element
    })
  })

  document.queryAll('[data-component="desktop-video"]').forEach(element => {
    new DesktopVideo({
      element
    })
  })

  document.queryAll('[data-component="mobile-video"]').forEach(element => {
    new MobileVideo({
      element
    })
  })

  document.queryAll('[data-component="fixed-logo"]').forEach(element => {
    new FixedLogo({
      element
    })
  })

  document.queryAll('[data-component="thats-it"] div').forEach(element => {
    new MarqueeText({
      element
    })
  })

  document.queryAll('[data-component="home-slider"]').forEach(element => {
    new HomeSlider({
      element,
      hurdler
    })
  })

  document.queryAll('[data-component="studio"]').forEach(element => {
    new Studio({
      element,
      hurdler
    })
  })

  document.queryAll('[data-component="contact"]').forEach(element => {
    new Contact({
      element,
      hurdler
    })
  })

  document.queryAll('[data-component="work-items"]').forEach(element => {
    new WorkItems({
      element
    })
  })

  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element
    })
  })

  document.queryAll('[data-component="centered-text-block"]').forEach(element => {
    new CenteredTextBlock({
      element
    })
  })

  document.queryAll('[data-component="global-footer"]').forEach(element => {
    new GlobalFooter({
      element
    })
  })

  document.queryAll('[data-component="open-closed"]').forEach(element => {
    new OpenClosed({
      element
    })
  })

  document.queryAll('[data-component="now-playing"]').forEach(element => {
    new NowPlaying({
      element
    })
  })

  document.queryAll('.in-view').forEach(element => {
    new InView({
      element
    })
  })

  hurdler.run()

})



// WEBPACK FOOTER //
// ./components/app/index.js